import React from 'react';
import { Table } from 'semantic-ui-react';
import type { CommunicationData } from 'types';

import ZendeskRow from './zendeskRow';

type _ZendeskCommunication = {
  extension?: Array<{
    url: string;
    valueString?: string;
  }>;
  id: string;
  identifier?: Array<{
    system: string;
    value: string;
  }>;
  medium?: Array<{
    coding?: Array<{
      code: string;
      display: string;
      system: string;
    }>;
    text: string;
  }>;
  note?: Array<{ text: string; time?: string }>;
  received?: string;
  sender?: {
    display?: string;
  };
  status?: string;
  topic?: { text: string };
  [key: string]: unknown;
};

type ZendeskTableProps = {
  debugCommunications: CommunicationData; //clean up with type TODO
  communicationsMutate: () => Promise<CommunicationData | undefined>;
  handleErrorMessage: (errorMessage: string) => void;
};

const ZendeskTable: React.FC<ZendeskTableProps> = ({
  debugCommunications,
  communicationsMutate,
  handleErrorMessage,
}) => {
  return (
    <div className="table-div">
      <Table sortable celled singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Ticket ID</Table.HeaderCell>
            <Table.HeaderCell>Channel</Table.HeaderCell>
            <Table.HeaderCell>Phone/Email</Table.HeaderCell>
            {/* <Table.HeaderCell>Type</Table.HeaderCell> */}
            <Table.HeaderCell>Assignee</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>DateTime</Table.HeaderCell>
            <Table.HeaderCell>Assign Member</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {debugCommunications.entry.map((communication, index) => (
            <ZendeskRow
              key={index}
              debugCommunication={communication.resource}
              communicationsMutate={communicationsMutate}
              handleErrorMessage={handleErrorMessage}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ZendeskTable;
